import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, BiDataHook, ReferralType, } from '@wix/da-bi/pkg/constants';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import PremiumIcon from '@wix/da-ds/pkg/Icons/Premium';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import ActionBarItemWrapper from '../../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../../_partials/items/ActionBarButton';
import ActionBarIcon from '../../../_partials/ActionBarIcon';
import SubscribeToUnlockTooltip from '../../../_partials/SubscribeToUnlockTooltip';
var FreeDownloadLink = function (props) {
    var deviation = props.deviation, _a = props.deviation, deviationId = _a.deviationId, _b = _a.extended, _c = _b === void 0 ? {} : _b, download = _c.download, onDownload = props.onDownload, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, iconRef = props.iconRef;
    var t = useTranslation().t;
    var _d = useRestrictToLoggedIn(), isLoggedIn = _d.isLoggedIn, restrictToLoggedIn = _d.restrictToLoggedIn;
    var _e = useSubscriptionTier(deviation), isBlockedBySubscription = _e.isBlockedBySubscription, tierCheckoutUrl = _e.tierCheckoutUrl;
    if (!download) {
        return null;
    }
    // 3 layers here: anon, unsubbed tier, then finally the download itself
    var buttonProps = {};
    if (!isLoggedIn) {
        buttonProps = { onClick: restrictToLoggedIn(ReferralType.ANON_DOWNLOAD) };
    }
    else if (isBlockedBySubscription) {
        buttonProps = { href: tierCheckoutUrl };
    }
    else if (!isBlockedBySubscription) {
        buttonProps = {
            href: download.url,
            download: true,
            target: '_blank',
            onClick: onDownload,
        };
    }
    var button = (React.createElement(ActionBarButton, __assign({ "data-hook": BiDataHook.DEVIATION_DOWNLOAD_BUTTON, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, biData: {
            evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
            deviationid: deviationId,
            ispaiddownload: 0,
        } }, buttonProps),
        React.createElement(ActionBarIcon, { icon: isBlockedBySubscription ? PremiumIcon : DownloadIcon, iconRef: iconRef })));
    var tooltip = isLoggedIn
        ? t('actionbar.download')
        : t('actionbar.download.mustLogIn');
    return isLoggedIn && isBlockedBySubscription ? (React.createElement(SubscribeToUnlockTooltip, { deviation: deviation }, button)) : (React.createElement(ActionBarItemWrapper, { tooltip: tooltip }, button));
};
FreeDownloadLink.displayName = 'FreeDownloadLink';
export default FreeDownloadLink;
//# sourceMappingURL=FreeDownloadLink.js.map